export const Props = () => ({
  //Ссылка на миниатюру
  src: {
    type: String,
  },

  //Подпись к миниатюре
  label: {
    type: String,
  }
});